import { CardInformativeDescriptionVariants } from './card-informative-description.styles'

type CardInformativeDescriptionProps = {
  children: React.ReactNode
}
export const CardInformativeDescription = (
  props: CardInformativeDescriptionProps
) => {
  const { children } = props
  return (
    <p {...props} className={CardInformativeDescriptionVariants({})}>
      {children}
    </p>
  )
}
